import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=3323cb33&scoped=true&"
import script from "./FileView.vue?vue&type=script&lang=ts&"
export * from "./FileView.vue?vue&type=script&lang=ts&"
import style0 from "./FileView.vue?vue&type=style&index=0&id=3323cb33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3323cb33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VSlideGroup,VSlideItem})
